<template lang="pug">
section
  s-page-title(title='Пользователи')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(@click='onEdit(props.item.id)' class='with-pointer')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Имя пользователя') {{ props.item.name }}
          td(data-label='Email') {{ props.item.email }}
          td(data-label='Телефон' class='wrapless') {{ props.item.phone | phone }}
          td(data-label='Клиент') 
            v-icon(v-if="props.item.is_client" dark color="primary") done
          td(data-label='Менеджер') 
            v-icon(v-if="props.item.is_manager" dark color="primary") done
          td(data-label='Статус') {{ props.item.status }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item.id)')
              v-icon(small) delete_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      { text: '#ID', align: 'left', value: 'id', width: '0%' },
      {
        text: 'Имя пользователя',
        align: 'left',
        value: 'name',
        width: '25%'
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
        width: '25%'
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone',
        width: '25%'
      },
      {
        text: 'Клиент',
        align: 'center',
        value: 'is_client',
        width: '2%',
        sortable: false
      },      
      {
        text: 'Менеджер',
        align: 'center',
        value: 'is_manager',
        width: '2%',
        sortable: false
      },            
      {
        text: 'Статус',
        align: 'left',
        value: 'status',
        width: '19%'
      },
      { text: '', align: 'left', width: '0%', sortable: false }
    ]
  }),

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    async onDelete(id) {
      if (await this.$confirm('Удалить менеджера?')) {
        await this.destroy({ id })
        this.fetch()
      }
    },

    onEdit(id) {
      this.$router.push({
        name: 'Admin.Users.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('admin/users', ['fetchList', 'destroy']),
    ...mapMutations('admin/users', ['setDataFilter'])
  },

  computed: {
    ...mapState('admin/users', ['total', 'dataFilter']),
    ...mapGetters('admin/users', ['list', 'isLoading'])
  }
}
</script>
